import NestedAnnouncementComponent from '../../components/announcementComponent/announcementComponent'

export const NestedAnnouncement = () => <NestedAnnouncementComponent />
